import { createAction, props } from '@ngrx/store';
import { ConsultantModel } from 'app/core/mips/common/models/consultant.model';

export const setUser = createAction('[CurrentUser] Set User', props<{ user: ConsultantModel }>());
export const clearUser = createAction('[CurrentUser] Clear User');